function dehighlightNodes(callback) {
  let nodes;
  if (!arguments.length) { //모두 
    nodes = this.filterNodes().classed('highlight', false).call(this.dehighlight);
  } else {
    nodes = this.filterNodes(callback).classed('highlight', false).call(this.dehighlight);
  }
  
  return nodes;
}
export default dehighlightNodes;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/default/dehighlightNodes.js